const img = require('./porchSideD_active.svg'); export default img;